import {ReactNode, CSSProperties} from 'react';

export enum EPopupDirections {
	POPUP_DIRECTION_TOP_TO_BOTTOM = 'TTB',
	POPUP_DIRECTION_BOTTOM_TO_TOP = 'BTT',
	POPUP_DIRECTION_LEFT_TO_RIGHT = 'LTR',
	POPUP_DIRECTION_NONE = 'NONE',
}

export interface IPopupProps {
	id: string;
	children: ReactNode | ReactNode[];
	direction?: EPopupDirections;
	onClose?: () => void;
	className?: string;
	overlayClassName?: string;
	popupContentClassName?: string;
	showCloseButton?: boolean;
	isSoftScroll?: boolean;
	closeButtonClassName?: string;
	closeButtonDimension?: {
		width?: number;
		height?: number;
	};
	closeButtonLabel?: ReactNode;
	onAfterOpen?: () => void;
	onAfterClose?: () => void;
	restoreScrollPosition?: boolean;
	style?: {
		overlay?: CSSProperties;
		content?: CSSProperties;
	};
	shouldCloseOnEsc?: boolean;
	shouldCloseOnOverlayClick? : boolean;
}
